import { createStore as _createStore, type StoreApi } from "zustand";

type SelectionStoreState = {
	isGhostMode: boolean;
};

const INITIAL_STATE: SelectionStoreState = {
	isGhostMode: false,
};

function createStore(): StoreApi<SelectionStoreState> {
	return _createStore<SelectionStoreState>(() => INITIAL_STATE);
}

export type { SelectionStoreState };
export { createStore };
